import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Stack } from "../../components";
import { useTranslation } from "../../language";

export const QueueNumberPage = () => {
	const translate = useTranslation();
	const navigate = useNavigate();
	const params = useParams();
	var [countDowner, setCountDowner] = useState(10);
	const timeoutRef = useRef<any>();
	const intervalRef = useRef<any>();

	useEffect(() => {
		timeoutRef.current = setTimeout(() => {
			navigate("/");
		}, countDowner * 1000);

		intervalRef.current = setInterval(() => {
			setCountDowner(--countDowner);
		}, 1000);
		return () => {
			if (timeoutRef.current) {
				clearTimeout(timeoutRef.current);
				timeoutRef.current = null;
			}

			if (intervalRef.current) {
				clearInterval(intervalRef.current);
				intervalRef.current = null;
			}
		}
	}, []);

	const getGoingBackText = () => {
		if (countDowner <= 0) {
			return translate("Register.QueueNumber.GoingBack");
		} else if (countDowner === 1) {
			return translate("Register.QueueNumber.GoingBackInOneSecond");
		} else {
			return translate("Register.QueueNumber.GoingBackInSeconds", { seconds: countDowner })
		}
	}

	return (<>
		<Stack style={{ padding: 70 }}>
			<Stack horizontal >
				<p style={{ fontSize: '2rem' }}>{translate("QueueDisplay.Description1")}</p>
			</Stack>
			<Stack horizontal >
				<p style={{ fontSize: '2rem' }}>{translate("QueueDisplay.Description2")}</p>
			</Stack>
			<Stack horizontal >
				<h1 style={{ fontSize: '5rem' }}>{translate("Register.QueueNumber.YourNumberIs", { number: params.queueNumber })}</h1>
			</Stack>
			<Stack horizontal >
				<p style={{ fontSize: '1.3rem' }}>{getGoingBackText()}</p>
			</Stack>
		</Stack>
	</>);
};
